import moment from 'moment';
import 'moment/locale/de';

const germanPatch = {
  monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
};

moment.updateLocale('de', germanPatch);

/**
 * ==================================================
 * = Code Diaries
 * = Chapter: My week is not your week
 * ==================================================
 *
 * Some weeks tend to start in the past year, so the
 * first week can break your code in unexpected ways
 *
 * ..to be continued
 */
export const objToMoment = (obj: string | Date | moment.Moment, inputFormat: string, locale: string = 'de-DE', strictCheck: boolean = true) => {
  // make sure moment has the right locale
  if (locale && !locale.startsWith(moment.locale())) {
    moment.locale(locale);
  }

  let date = moment.utc(obj, inputFormat, strictCheck);
  const lowerInputFormat = inputFormat.toLowerCase();

  if (lowerInputFormat.includes('w') && date.week() === 1) {
    date = date.endOf('week').startOf('day');
  }

  const isHourDay = lowerInputFormat === 'hh:mm' || lowerInputFormat.includes('d');
  const isYearQuarterMonth = lowerInputFormat === 'yyyy' || lowerInputFormat.includes('q') || lowerInputFormat.includes('m');

  if (!isHourDay && isYearQuarterMonth) {
    date = date.add(1, 'days');
  }

  // console.log('[objToMoment] - 3', { currentLocale: moment.locale(), locale, date, obj });
  return date;
};

export const momentToStr = (obj: moment.Moment, outputFormat: string, locale: string = 'de-DE') => {
  const lowerOutputFormat = outputFormat.toLowerCase();
  if (lowerOutputFormat.includes('w')) {
    outputFormat = outputFormat.replace('YYYY', 'GGGG');
  }

  obj = moment.isMoment(obj) ? obj : moment(obj);
  return obj.locale(locale).format(outputFormat);
};

export const guessDateFormat = (obj: string | Date | moment.Moment) => {
  return moment(obj).creationData().format;
};
